(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password"]) return;
  try {
    
  class ComingSoonCountdown extends HTMLElement {
    connectedCallback() {
      this.targetDate = new Date(this.dataset.target.replace(' ', 'T'));

      if (Number.isNaN(this.targetDate.getTime())) {
        this.hidden = true;
        return;
      }

      this.daysEl = this.querySelector('[data-unit="days"]');
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');

      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    update() {
      const remaining = this.targetDate.getTime() - Date.now();

      if (remaining <= 0) {
        clearInterval(this.interval);
        this.hidden = true;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);

      this.daysEl.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      this.hoursEl.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      this.minutesEl.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      this.secondsEl.textContent = String(totalSeconds % 60).padStart(2, '0');
    }
  }

  customElements.define('coming-soon-countdown', ComingSoonCountdown);

  } catch(e) { console.error(e); }
})();
})();
